/**
 * @generated SignedSource<<e86a1a255d0dd4cfe61cd45f14460351>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingPhaseContextRefetchViewerQuery$variables = {};
export type MeetingPhaseContextRefetchViewerQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"MeetingPhaseContext_viewer">;
  };
};
export type MeetingPhaseContextRefetchViewerQuery = {
  response: MeetingPhaseContextRefetchViewerQuery$data;
  variables: MeetingPhaseContextRefetchViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingPhaseContextRefetchViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MeetingPhaseContext_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingPhaseContextRefetchViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasCopilotAddon",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "meeting_recorder"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"meeting_recorder\")"
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowMeetingRecording",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remainingMeetingRecordingCredits",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToCopilot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAccessToScheduledMeetingRecordings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserMeetingRecapAutoShareSettings",
            "kind": "LinkedField",
            "name": "meetingRecapAutoShareSettings",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendTo",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6892a37e20a7cb8590f0cec2686d32a",
    "id": null,
    "metadata": {},
    "name": "MeetingPhaseContextRefetchViewerQuery",
    "operationKind": "query",
    "text": "query MeetingPhaseContextRefetchViewerQuery {\n  viewer {\n    id\n    ...MeetingPhaseContext_viewer\n  }\n}\n\nfragment MeetingPhaseContext_viewer on Viewer {\n  ...featureFlag_useCopilotPaywallsOn_viewer\n  remainingMeetingRecordingCredits\n  hasAccessToCopilot\n  hasAccessToScheduledMeetingRecordings\n  hasAdminAccess\n  account {\n    allowMeetingRecording\n    id\n  }\n  user {\n    id\n  }\n  meetingRecapAutoShareSettings {\n    id\n    sendTo\n  }\n}\n\nfragment featureFlag_useCopilotPaywallsOn_viewer on Viewer {\n  account {\n    billingAccount {\n      hasCopilotAddon: hasAccessToFeature(feature: meeting_recorder)\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "71858186fb24e4ae9d093ca69f74e967";

export default node;
